<template>
    <div class="card" style="width: 100%;">
        <div class="card-body">
            <div class="row">
                <div class="col-md-10">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-12">
                                    <strong>Aluno: </strong>{{ aula.alunoNome }}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <strong>CPF: </strong>{{ aula.alunoCPF }}
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-12">
                                    <strong>Instrutor: </strong>{{ aula.instrutorNome }}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <strong>Data: </strong>{{ aula.aulaPraticaData }}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 d-inline">
                                    <strong style="display: inline">Status: </strong><span class="mr-2">{{ aula.aulaPraticaStatus ? aula.aulaPraticaStatus : "PENDENTE" }}</span>
                                    <!-- <status-drop-down :aulaId="aula.aulaPraticaId" :schema="aula.schema" style="display: inline-block" @handled="removerAula(index)" /> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-2 d-flex justify-content-end align-items-center" style="gap: 5px">
                    <button class="btn-operation" title="Enviar Aula" v-if="!statusEnviados !== 'Aceito'" @click="$emit('sendClassroom')"><i class="fa fa-paper-plane"></i></button>
                    <button class="btn-operation" title="Modificar aula" @click="$emit('abrirModificacaoAula')"><i class="fa fa-wrench"></i></button>
                    <button class="btn-operation" title="Visualizar aulas do instrutor" @click="$emit('abrirAulasDoInstrutor')"><i class="fa fa-list"></i></button>
                    <button class="btn-operation" title="Visualizar aulas do aluno" @click="$emit('abrirAulasDoAluno')"><i class="fa fa-eye"></i></button>
                    <button class="btn-operation" title="Remover Anotação" @click="$emit('removerAnotacao')"><i class="fa fa-times"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'CardAula',
    props: {
        aula: Object
    },
    data() {
        return {
            statusEnviados: ['Em análise', 'Aceito', 'Transação efetuada com sucesso']
        }
    }
}
</script>